/**
 * Navigation bridge.
 *
 * Non-component code — the axios interceptor, the zustand auth store, the
 * class-based ErrorBoundary — needs to navigate, but only React-Router
 * components have access to `useNavigate`. On the web a hard
 * `window.location.assign('/login')` works fine; inside Capacitor it
 * white-screens because the embedded server has no SPA fallback and the app
 * runs under a hash history.
 *
 * `<RouterBridge/>` (mounted inside the Router in App.jsx) registers the live
 * `navigate` function here. `navigateTo()` then routes through React-Router when
 * available, falling back to `window.location` only if called before the bridge
 * mounts (extremely early boot).
 */
let _navigate = null;

export function setNavigator(fn) {
  _navigate = fn;
}

export function clearNavigator() {
  _navigate = null;
}

/**
 * Navigate to an in-app path. `to` is a normal router path ('/login').
 * Returns true if it went through the SPA router, false if it fell back.
 */
export function navigateTo(to, opts = {}) {
  if (typeof _navigate === 'function') {
    _navigate(to, opts);
    return true;
  }
  if (typeof window !== 'undefined') {
    window.location.assign(to);
  }
  return false;
}
